import TemplateView from "../../TemplateView"
import UserTime from "../../user_time"
import {AuditHistoryView} from "../auditHsitory/AuditHistoryView"
import CustomerStatusButton from  "../../controls/task/CustomerStatusButton"

export default class CustomerPanelDetails extends TemplateView {
    constructor($containerEl) {
        super($containerEl);
        this.state = {
            active: false,
            readOnly: false,
            spentTimeValues: {},
        }

        this.onStatePropertyChanged('spentTimeValues', () => {
            this.updateSpentTime()
        })

        this.onStatePropertyChanged('readOnly', () => {
            this.statusButton.setEditable(!this.state.readOnly)
        })

        this.onStatePropertyChanged('active', () => {
            this.statusButton.setActive(this.state.active)
        })
    }

    templateHtml() {
        return "<div class='auditHistoryPlaceholder'/>" +
               "<div class='detailsColumn'>" +
               "  <div class='title'><%=details%></div>" +
               "  <div class='status'><%=status%></div>" +
               "  <div class='statusButton'></div>" +
               "</div>" +
               "<div class='timeColumn'>" +
               "  <div class='totalSpentTime'>" +
               "    <span class='descriptionTime ellipsis'><%-totalTime%></span>" +
               "    <span class='time'></span>" +
               "  </div>" +
               "  <div class='activeProjects'>" +
               "    <span class='descriptionTime ellipsis'><%-activeTime%></span>" +
               "    <span class='time'></span>" +
               "  </div>" +
               "  <div class='archiveProjects'>" +
               "    <span class='descriptionTime ellipsis'><%-archiveTime%></span>" +
               "    <span class='time'></span>" +
               "  </div>" +
               "</div>";
    }

    messageKeys() {
        return {
            totalTime: "customer.edit_panel.total_spent_time",
            activeTime: "customer.edit_panel.active_spent_time",
            archiveTime: "customer.edit_panel.archived_spent_time",
            status: "common.status",
            details: "customer.edit_panel.details"
        }
    }

    afterRender() {
        this.$timeColumn = this.$containerEl.find('.timeColumn')
        this.$totalTime = this.$containerEl.find(".totalSpentTime .time");
        this.$activeTime = this.$containerEl.find(".activeProjects .time");
        this.$archivedTime = this.$containerEl.find(".archiveProjects .time");
        this.$statusButton = this.$containerEl.find(".statusButton");

        this.auditHistory = new AuditHistoryView({
            extraClass: 'customerAudit',
        }).init(this.$containerEl.find('.auditHistoryPlaceholder'));
        let dateFormat = Date.convertSmartToExtDateFormat(window.SystemSettings.dateFormat).replace(/F/, "M");
        this.auditHistory.setDateFormat(dateFormat);
        this.statusButton = new CustomerStatusButton({
            editable: true,
        }).init(this.$statusButton)

        this.statusButton.on('change', (e, active)=> this.setStateInternal({active}))
    }

    updateSpentTime() {
        if (this.state.spentTimeValues) {
            this.$timeColumn.show()
            this.$activeTime.text(UserTime.formatTimeWithDigitSeparator(this.state.spentTimeValues.activeProjectsTime))
            this.$totalTime.text(UserTime.formatTimeWithDigitSeparator(this.state.spentTimeValues.spentTime))
            this.$archivedTime.text(UserTime.formatTimeWithDigitSeparator(this.state.spentTimeValues.archivedProjectsTime))
        } else {
            this.$timeColumn.hide()
        }
    }

    hideSelectors() {
        this.statusButton.disableAndHide();
    }

    setSelectorsDisabled(disabled) {
        this.statusButton.setDisabled(disabled);
    }

    clearAuditHistory() {
        this.auditHistory.hide();
    }

    setAuditHistory(createAction, lastUpdateAction) {
        this.auditHistory.setAuditActions(createAction, lastUpdateAction, []);
    }

    setLastAudit(lastUpdateAudit) {
        this.auditHistory.setLastAuditAction(lastUpdateAudit)
    }

    addAuditRecords(auditRecords) {
        this.auditHistory.addRecords(auditRecords);
    }

    setAuditRecords(auditRecords) {
        this.auditHistory.setRecords(auditRecords);
    }

    hideAuditHistoryMenu() {
        this.auditHistory.auditHistoryMenu.hide();
    }
}




// WEBPACK FOOTER //
// ./web/js/panels/customer/CustomerPanelDetails.js